import React from 'react'
import { Button, withStyles } from '@material-ui/core'
import style from './style'

const ControlButtonsSection = ({
  classes,
  onBack,
  userRole,
  onClickEdit,
  onDuplicateSequence,
  isEnrollment = false,
}) => {
  return (
    <div className={classes.wrapper}>
      <div className={classes.topButtonWrapper}>
        <div>
          <Button
            className={[classes.button, classes.backButton]}
            variant="outlined"
            onClick={onBack}
          >
            Back
          </Button>
          {isEnrollment && (
            <Button
              className={classes.button}
              variant="outlined"
              onClick={onClickEdit}
            >
              Edit Sequence
            </Button>
          )}
        </div>

        {isEnrollment && userRole === 'ADMIN' && (
          <Button
            className={classes.button}
            variant="outlined"
            onClick={onDuplicateSequence}
          >
            Copy sequences to other cities
          </Button>
        )}
      </div>
    </div>
  )
}

export default withStyles(style)(ControlButtonsSection)
